import { render, staticRenderFns } from "./05-PetascaleScientificDiscovery.md?vue&type=template&id=33bed0f9&"
import script from "./05-PetascaleScientificDiscovery.md?vue&type=script&lang=js&"
export * from "./05-PetascaleScientificDiscovery.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports